import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppController, setLayout, setMiniSidenav } from 'context';
import { cn } from 'components/shadcn/lib/utils';
import HGFooter from 'components/HGFooter';
import Sidenav from 'components/Sidenav';
import TopNav from 'components/TopNav';

function AppLayout({ routes, brand, brandMini, children }) {
    const [controller, dispatch] = useAppController();
    const { miniSidenav } = controller;
    const { pathname } = useLocation();
    const [onMouseEnter, setOnMouseEnter] = useState(false);

    useEffect(() => {
        setLayout(dispatch, 'dashboard');
    }, [pathname, dispatch]);

    const handleOnMouseEnter = () => {
        if (miniSidenav && !onMouseEnter) {
            setMiniSidenav(dispatch, false);
            setOnMouseEnter(true);
        }
    };

    const handleOnMouseLeave = () => {
        if (onMouseEnter) {
            setMiniSidenav(dispatch, true);
            setOnMouseEnter(false);
        }
    };

    return (
        <>
            <Sidenav
                brand={brand}
                brandMini={brandMini}
                routes={routes}
                onMouseEnter={handleOnMouseEnter}
                onMouseLeave={handleOnMouseLeave}
            />
            <div
                className={cn(
                    'flex h-dvh flex-col overflow-hidden p-3 pt-16 transition-all duration-300',
                    'xl:pt-3',
                    miniSidenav ? 'xl:ml-20' : 'xl:ml-48'
                )}
            >
                {/* Desktop: TopNav stays fixed above scroll area */}
                <div className="hidden xl:block shrink-0">
                    <TopNav />
                </div>
                <div className="flex-1 overflow-y-auto xl:pt-5">
                    {/* Mobile: TopNav scrolls with content */}
                    <div className="mb-5 pt-3 xl:hidden">
                        <TopNav />
                    </div>
                    {children}
                    <HGFooter />
                </div>
            </div>
        </>
    );
}

export default AppLayout;
